(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["charms_announcement_bar_off"] && !Shopify.designMode) return;
  try {
    
  class CharmsAnnouncement extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-charms-track]');
      this.slides = Array.from(this.querySelectorAll('[data-charms-slide]'));
      if (!this.track || this.slides.length === 0) return;

      this.index = 0;
      this.timer = null;

      const prev = this.querySelector('[data-charms-prev]');
      const next = this.querySelector('[data-charms-next]');
      if (prev) prev.addEventListener('click', () => this.step(-1));
      if (next) next.addEventListener('click', () => this.step(1));

      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());

      this.go(0);
      this.start();
    }

    disconnectedCallback() {
      this.stop();
    }

    step(direction) {
      const total = this.slides.length;
      this.go((this.index + direction + total) % total);
    }

    go(index) {
      this.index = index;
      this.track.style.transform = 'translateX(' + index * -100 + '%)';
      this.slides.forEach((slide, i) => {
        if (i === index) {
          slide.removeAttribute('aria-hidden');
        } else {
          slide.setAttribute('aria-hidden', 'true');
        }
      });
    }

    start() {
      this.stop();
      if (this.slides.length < 2) return;
      if (this.dataset.autoplay !== 'true') return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const speed = parseInt(this.dataset.speed, 10) || 5;
      this.timer = setInterval(() => this.step(1), speed * 1000);
    }

    stop() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }
  }

  if (!customElements.get('charms-announcement')) {
    customElements.define('charms-announcement', CharmsAnnouncement);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["charms_product_layout_offer"] && !Shopify.designMode) return;
  try {
    
  class CharmsGallery extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-charms-viewport]');
      this.slides = Array.from(this.querySelectorAll('[data-charms-slide]'));
      this.thumbs = Array.from(this.querySelectorAll('[data-charms-thumb]'));
      if (!this.viewport || this.slides.length === 0) return;

      this.index = 0;

      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          this.goTo(parseInt(thumb.dataset.index, 10) || 0);
        });
      });

      const prev = this.querySelector('[data-charms-prev]');
      const next = this.querySelector('[data-charms-next]');
      if (prev) prev.addEventListener('click', () => this.step(-1));
      if (next) next.addEventListener('click', () => this.step(1));

      this.viewport.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.step(1);
        } else if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.step(-1);
        }
      });

      this.onScroll = this.onScroll.bind(this);
      this.viewport.addEventListener('scroll', this.onScroll, { passive: true });
    }

    disconnectedCallback() {
      if (this.viewport) this.viewport.removeEventListener('scroll', this.onScroll);
      if (this.scrollTimer) clearTimeout(this.scrollTimer);
    }

    onScroll() {
      if (this.scrollTimer) clearTimeout(this.scrollTimer);
      this.scrollTimer = setTimeout(() => {
        const width = this.viewport.clientWidth;
        if (width === 0) return;
        this.setActive(Math.round(this.viewport.scrollLeft / width));
      }, 80);
    }

    step(direction) {
      const total = this.slides.length;
      let target = this.index + direction;
      if (this.dataset.loop === 'true') {
        target = (target + total) % total;
      } else {
        target = Math.max(0, Math.min(total - 1, target));
      }
      this.goTo(target);
    }

    goTo(index) {
      const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      this.viewport.scrollTo({ left: this.viewport.clientWidth * index, behavior: behavior });
      this.setActive(index);
    }

    setActive(index) {
      if (index === this.index) return;
      this.index = index;
      this.thumbs.forEach((thumb, i) => {
        if (i === index) {
          thumb.classList.add('is-active');
          thumb.setAttribute('aria-current', 'true');
        } else {
          thumb.classList.remove('is-active');
          thumb.removeAttribute('aria-current');
        }
      });
    }
  }

  if (!customElements.get('charms-gallery')) {
    customElements.define('charms-gallery', CharmsGallery);
  }

  } catch(e) { console.error(e); }
})();
})();
